'use strict';

/**
 * This has been modified from
 * https://github.com/pathable/truncate
 */

var _ = require('underscore');
var DATA_ATTR = {
  ROOT: 'swTruncate',
  IS_TRUNCATED: 'isTruncated',
  OVER_LENGTH: 'overLength',
  FULL_TEXT: 'fullText'
};

// Matches trailing non-space characters.
var chop = /(\s*\S+|\s)$/;

var DEFAULTS = {

  // Strip all html elements, leaving only plain text.
  stripTags: false,

  // Only truncate at word boundaries.
  words: true,

  // Replace instances of <br> with a single space.
  noBreaks: false,

  // The maximum length of the truncated html.
  length: 300,

  // The character to use as the ellipsis.  The word joiner (U+2060) can be
  // used to prevent a hanging ellipsis, but displays incorrectly in Chrome
  // on Windows 7.
  // http://code.google.com/p/chromium/issues/detail?id=68323
  ellipsis: '\u2026', // '\u2060\u2026',

  // undo truncation
  undo: false

};

module.exports = function ($) {

  // Return a truncated html string.  Delegates to $.fn.truncate.
  $.swTruncate = function(html, options) {
    return $('<div></div>').append(html).truncate(options).html();
  };

  // Truncate the contents of an element in place.
  $.fn.swTruncate = function(options) {
    if ($.isNumeric(options)) {
      options = {length: options};
    }

    options = _.defaults(options || {}, DEFAULTS);

    return this.each(function() {
      var self = $(this);

      // keep track of state on a data attr
      var defaults = {};
      defaults[DATA_ATTR.FULL_TEXT] = self.html();
      defaults[DATA_ATTR.IS_TRUNCATED] = false;
      defaults[DATA_ATTR.OVER_LENGTH] = false;

      var truncateData = _.defaults(self.data(DATA_ATTR.ROOT) || {}, defaults);

      // support the ability to undo truncation
      if(options.undo) {
        self.html(truncateData[DATA_ATTR.FULL_TEXT]);
        truncateData[DATA_ATTR.IS_TRUNCATED] = false;
        self.data(DATA_ATTR.ROOT, truncateData);
        return;
      }

      if (options.noBreaks) {
        self.find('br').replaceWith(' ');
      }

      var text = self.text();
      var excess = text.length - options.length;

      if (options.stripTags) {
        self.text(text);
      }

      // Chop off any partial words if appropriate.
      if (options.words && excess > 0) {
        excess = text.length - text.slice(0, options.length).replace(chop, '').length - 1;
      }

      if (excess < 0 || !excess && !options.truncated) {
        // save state to data attr
        self.data(DATA_ATTR.ROOT, truncateData);
        return;
      }

      // Iterate over each child node in reverse, removing excess text.
      $.each(self.contents().get().reverse(), function(i, el) {
        var $el = $(el);
        var text = $el.text();
        var length = text.length;

        // If the text is longer than the excess, remove the node and continue.
        if (length <= excess) {
          options.truncated =  true;
          excess -= length;
          $el.remove();
          return;
        }

        // Remove the excess text and append the ellipsis.
        if (el.nodeType === 3) {
          // Note that we have truncated
          truncateData[DATA_ATTR.IS_TRUNCATED] = truncateData[DATA_ATTR.OVER_LENGTH] = true;
          $(el.splitText(length - excess - 1)).replaceWith(options.ellipsis);
          return false;
        }

        // Recursively truncate child nodes.
        // NB: careful when you use this, we should be explicit about when we want to truncate recursively,
        // especially when we're not sure about what content will be included.
        if (options.truncateChildren) {
          $el.swTruncate($.extend(options, {length: length - excess}));
        }

        return false;
      });

      // save state to data attr
      self.data(DATA_ATTR.ROOT, truncateData);
    });
  };

  $.swTruncate.DEFAULTS = $.fn.swTruncate.DEFALUTS = DEFAULTS;
  $.swTruncate.DATA_ATTR = $.fn.swTruncate.DATA_ATTR = DATA_ATTR;

};
